import { header } from './modules/header';
import { anchorlink } from './modules/anchorLink';
import { animation } from './modules/animation';
import { current } from './modules/current';
header();
anchorlink();
animation();
current();
